"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/material/styles");

var _constants = require("../constants");

// Constants
// https://material-ui.com/customization/palette/
var _default = (0, _styles.createTheme)({
  typography: {
    button: {
      textTransform: 'none'
    },
    h1: {
      fontSize: 50
    },
    h2: {
      fontSize: 38
    },
    h3: {
      fontSize: 32
    },
    h4: {
      fontSize: 26
    },
    fontFamily: ['Open Sans', 'Arial'].join(',')
  },
  palette: {
    primary: {
      light: _constants.ERGO_BLUE,
      main: _constants.BLUE,
      dark: _constants.DARK_BLUE,
      contrastText: _constants.TEXT_WHITE
    },
    secondary: {
      light: _constants.LIGHT_GREY,
      main: _constants.GREY,
      dark: _constants.DARK_GREY,
      contrastText: _constants.TEXT_WHITE
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'primary'
      },
      variants: [{
        props: {
          variant: 'contained',
          color: 'primary'
        },
        style: {
          backgroundColor: _constants.ERGO_BLUE
        }
      }, {
        props: {
          variant: 'contained',
          color: 'secondary'
        },
        style: {
          backgroundColor: _constants.GREY
        }
      }],
      styleOverrides: {
        root: {
          width: '100%'
        }
      }
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          boxSizing: 'border-box',
          margin: 0
        }
      }
    }
  }
});

exports.default = _default;